import React from "react"
import { Radio as RadioOg, RadioGroup } from "@chakra-ui/react"
import {
    HorizontalStack,
    type StyleProps,
} from "@mallardbay/lib-react-components"
import { componentStyles } from "@mallardbay/lib-react-components"

export interface RadioOption {
    label: string
    value: string
}

interface Props {
    readonly style?: StyleProps
    readonly name?: string
    readonly value: string | boolean
    readonly onChange: (value: string) => void
    readonly options: RadioOption[]
    readonly isDisabled?: boolean
    readonly isVertical?: boolean
}

export default function Radio({
    style,
    name,
    value,
    onChange,
    options,
    isDisabled,
    isVertical,
}: Props) {
    const styles = useStyles({ isVertical })

    // Convert boolean to string for Chakra compatibility since it expects a string value
    const stringValue = typeof value === "boolean" ? value.toString() : value

    return (
        <RadioGroup
            sx={style}
            name={name}
            value={stringValue}
            onChange={onChange}
            isDisabled={isDisabled}
        >
            <HorizontalStack style={styles.stack}>
                {options.map((option) => (
                    <RadioOg
                        key={option.value}
                        value={option.value}
                        colorScheme="brand"
                        sx={styles.radio}
                    >
                        {option.label}
                    </RadioOg>
                ))}
            </HorizontalStack>
        </RadioGroup>
    )
}

function useStyles({ isVertical }: { isVertical?: boolean }) {
    return componentStyles({
        stack: {
            flexDirection: isVertical ? "column" : "row",
            alignItems: isVertical ? "flex-start" : "center",
        },
        // on light mode the default radio color is making the circle's white and its on white background, making it invisible
        // unset here to let higher level components handle it to the correct color for light/dark mode
        radio: {
            color: "unset",
        },
    })
}
